import script from "./strike-failed.vue?vue&type=script&lang=js"
export * from "./strike-failed.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__